import 'leaflet/dist/leaflet.css';
import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, LayersControl , Polygon} from 'react-leaflet';
import L from 'leaflet';
import {Box} from "grommet";
import { db } from "../../firebase/firebase.js";
import {useSubscription} from "@apollo/client";
import {QUERY_GET_AREA_COORDS, QUERY_LIVE_POSITION} from "./MapLocationGQL.jsx";
import {tenant} from "../tenant.js";
const { BaseLayer } = LayersControl;

// Imposta l'icona predefinita di Leaflet
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const googleMapsStreetLayer = `https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}&s=Ga&key=AIzaSyBH__gEjglI0DzkCuq33ioG3_ayXHP4ojo`;
const googleMapsSatelliteLayer = `https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}&s=Ga&key=AIzaSyBH__gEjglI0DzkCuq33ioG3_ayXHP4ojo`;

const MapLocation = () => {
    const position = [45.1143043,10.6851701]; // Coordinate per il centro della mappa
    const [userLivePositionData,setUserLivePositioData]=React.useState([]);
    const [areaPolygons,setAreaPolygons]=React.useState([]);

    
    useEffect(() => {
        const unsubscribe = db
            .collection("users")
            .where("is_active", "==", true)
            .onSnapshot((snapshot) => {
                const users = snapshot.docs.map((doc) => {
                    const data = doc.data();
                    return {
                        id: doc.id,
                        lat: data.lat,
                        lng: data.lng,
                        nome: data.nome,
                        cognome: data.cognome
                    };
                });
                setUserLivePositioData(users);
            }, (error) => {
                console.error("Errore nel listener Firestore:", error);
            });
        return () => {
            console.log("rimuovo listener Firestore");
            unsubscribe();
        };
    }, []);

    
   /* useSubscription(QUERY_LIVE_POSITION,{
        onData:({data:data})=>{
            const dataApp=data["data"][`clubmate_usersregister_userliveposition`];
            if(dataApp){
                setUserLivePositioData(dataApp);
            }
        },
        onError:({error})=>{console.error(error)},
    });*/

    useSubscription(QUERY_GET_AREA_COORDS,{
        onData:({data:data})=>{
            const dataApp=data["data"][`clubmate_clubmatearea_clubmatearea`];
            if(dataApp){
                const polygonsCoordinates=[];
                for(let i=0;i<dataApp.length;i++){
                    let polygonsCoords=dataApp[i]?.coordinate?.coordinates[0] //la struttura dati di una singola area sembra fatta come multiplygon, ma in realtà è un polygon, quindi ne contiene solo uno
                    const polygon={"name":dataApp[i]?.name};
                    const polygonVertex=[];
                    for(let j=0;j<polygonsCoords.length;j++){ //Inverto lat e lng nei vertici
                        polygonVertex.push([polygonsCoords[j][1],polygonsCoords[j][0]]);
                    }
                    polygon["coords"]=polygonVertex;
                    polygonsCoordinates.push(polygon);
                }
                setAreaPolygons(polygonsCoordinates);
            }
        },
        onError:({error})=>{console.error(error)},
    });

    return (
        <Box margin="2px">
            <MapContainer center={position} zoom={35} style={{ height: "98vh", width: "100%" }}>
                <LayersControl position="topright">
                    <BaseLayer checked name="Street View">
                        <TileLayer
                            url={googleMapsStreetLayer}
                            attribution='&copy; <a href="https://www.google.com/maps">Google Maps</a>'
                        />
                    </BaseLayer>
                    <BaseLayer name="Satellite View">
                        <TileLayer
                            url={googleMapsSatelliteLayer}
                            attribution='&copy; <a href="https://www.google.com/maps">Google Maps</a>'
                        />
                    </BaseLayer>
                </LayersControl>
                {
                    Array.isArray(areaPolygons) && areaPolygons.map((polygon,i)=>{
                        return(
                            <Polygon key={i} pathOptions={{ fillColor: 'blue' }} positions={polygon?.coords} />
                        )
                    })
                }

                {userLivePositionData.map((el)=>{
                    return(
                        <Marker position={[el?.lat,el?.lng]}>
                            <Popup>
                                {el?.nome} {el?.cognome}
                            </Popup>
                        </Marker>
                    )
                })}

            </MapContainer>
        </Box>
    );
};

export default MapLocation;